export const useGridImageContentData = () => {
  const config = useRuntimeConfig()

  const transform = (response) => {
    const { sanitize } = useUtils();
    
    return {
      gridImageContent: sanitize(response.data.attributes.gridImageContent),
    }
  }    
  const getGridImageContent = async (deep = true) => {        
    const url = `/api/grid-image-content`;
    
    return await useFetch(url, {
      method: 'GET',            
      transform: transform
    });
  }
    
  return {
    getGridImageContent,
  }
}